import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { SearchHistoryItem, SearchListType, SearchStore } from '@store';

import { SearchService } from '../../search.service';

@Component({
  selector: 'app-search-history',
  templateUrl: './search-history.component.html',
  styleUrls: ['./search-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchHistoryComponent implements OnInit, OnDestroy {
  searchList$: BehaviorSubject<SearchHistoryItem[]> = new BehaviorSubject<SearchHistoryItem[]>(
    undefined
  );

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private searchService: SearchService, private searchStore: SearchStore) {}

  ngOnInit(): void {
    this.getSearchList();
  }

  getSearchList(): void {
    this.searchStore
      .getSearchHistory()
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((list) => !isEmpty(list) && !isEmpty(list.searchList)),
        map((list) => list.searchList)
      )
      .subscribe((list) => {
        this.searchList$.next(list);
      });
  }

  invokeSearch(searchParams: any): void {
    const active =
      searchParams.type.toLowerCase() === 'boiler' ? 'gateway' : searchParams.type.toLowerCase();
    this.searchService.activeSearch$.next(active);
    this.searchService.onSearchHistoryEntryClicked$.next(searchParams);
  }

  getIconBasedOnType(type: SearchListType): string {
    switch (type) {
      case 'Gateway':
        return 'gateway-heatbox';
      case 'Boiler':
        return 'boiler';
      case 'User':
        return 'user';
      case 'Error':
        return 'error';
      case 'location':
      default:
        return 'location';
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
